module.exports = __webpack_public_path__ + "fee-49ec1f18454a55cd78af88eb51a0c927.png";